export default __webpack_public_path__ + "1.png";